<template>
  <div class="tile flex flex-col space-y-4 lg:space-y-6">
    <h1 class="text-2xl sm:text-3xl font-bold text-center">{{ terms.name }}</h1>
    <ul
      v-for="(term, i) in terms.content"
      :key="i"
      class="text-sm sm:text-base"
    >
      <li class="flex">
        <div class="flex-shrink-0 w-8 sm:w-10 sm:text-lg font-semibold">
          {{ i + 1 }}.
        </div>
        <div class="min-w-0 flex-1">
          <span class="sm:text-lg font-semibold uppercase">{{
            term.heading
          }}</span>
          <ol v-for="(clause, j) in term.clauses" :key="j">
            <li class="pt-2 flex">
              <div class="flex-shrink-0 w-8 sm:w-10">
                {{ i + 1 }}.{{ j + 1 }}
              </div>
              <div class="min-w-0 flex-1">
                <div class="min-w-0 flex-1" v-if="typeof clause === 'object'">
                  <span v-html="clause.subheading"></span>
                  <ol v-for="(subclause, k) in clause.subclauses" :key="k">
                    <li class="pt-2 flex">
                      <div class="flex-shrink-0 w-8 sm:w-10">
                        ({{ letters[k] }})
                      </div>
                      <div
                        class="min-w-0 flex-1"
                        v-if="typeof subclause === 'object'"
                      >
                        <span v-html="subclause.subsubheading"></span>
                        <ol
                          v-for="(subsubclause, l) in subclause.subsubclauses"
                          :key="l"
                        >
                          <li class="pt-2 flex">
                            <div class="flex-shrink-0 w-8 sm:w-10">
                              ({{ romanNumerals[l] }})
                            </div>
                            <span v-html="subsubclause"></span>
                          </li>
                        </ol>
                      </div>
                      <span v-else v-html="subclause"></span>
                    </li>
                  </ol>
                </div>
                <span v-else v-html="clause"></span>
              </div>
            </li>
          </ol>
        </div>
      </li>
    </ul>
    <p class="italic text-sm sm:text-base">
      The English version of this document is the definitive version.
      Translations into other languages are provided for information only.
    </p>
    <p class="italic text-right text-sm sm:text-base">
      Last updated: {{ terms.lastUpdated }}
    </p>
  </div>
</template>

<script setup>
const letters = [
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
];
const romanNumerals = [
  "i",
  "ii",
  "iii",
  "iv",
  "v",
  "vi",
  "vii",
  "viii",
  "ix",
  "x",
];
</script>

<script>
export default {
  props: {
    terms: Object,
  },
};
</script>
